import Link from 'next/link'
import type { ReactNode } from 'react'
import styles from './MarketingShell.module.css'

export default function MarketingShell(props: { children: ReactNode }) {
  return (
    <main className={styles.page}>
      <div className={styles.backdrop} aria-hidden />
      <div className={styles.container}>
        <header className={styles.header}>
          <Link href="/" className={styles.brand}>
            <span className={styles.mark} aria-hidden />
            <span className={styles.brandText}>DuoElevate</span>
          </Link>

          <nav className={styles.nav}>
            <Link href="/pricing" className={styles.link}>
              Pricing
            </Link>
            <Link href="/about" className={styles.link}>
              About
            </Link>
            <a href="/api/health" className={styles.link}>
              Health
            </a>
            <Link href="/login" className={`${styles.link} ${styles.primary}`}>
              Sign in
            </Link>
          </nav>
        </header>

        {props.children}

        <footer className={styles.footer}>
          <div className={styles.footerRow}>
            <span>© {new Date().getFullYear()} DuoElevate</span>
            <div className={styles.footerLinks}>
              <Link href="/privacy" className={styles.footerLink}>
                Privacy
              </Link>
              <Link href="/terms" className={styles.footerLink}>
                Terms
              </Link>
              <span>Built by Duoinfotech</span>
            </div>
          </div>
        </footer>
      </div>
    </main>
  )
}
